var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"vxeGrid",attrs:{"auto-resize":"","highlight-hover-row":"","toolbar-config":_vm.tableToolbar,"loading":_vm.loading,"data":_vm.tableData,"columns":_vm.tableColumns,"size":"small","height":300},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header",[_c('div',{staticClass:"side-frame-success"},[_c('span',{staticStyle:{"font-size":"14px","color":"#606266"}},[_vm._v(_vm._s(_vm.$l('group_title_dep') || '部门执行统计'))])])])]},proxy:true},{key:"showBudget",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.v_annualBudget)+" ")]}},{key:"showSales",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.v_orderAmount)+" ")]}},{key:"rateOfProgress",fn:function(ref){
var row = ref.row;
return [_c('div',[_c('b-progress',{staticStyle:{"width":"200px"},attrs:{"variant":row.completionRate <= 20
              ? 'danger'
              : row.completionRate > 20 && row.completionRate <= 40
              ? 'warning'
              : row.completionRate > 40 && row.completionRate <= 60
              ? 'secondary'
              : row.completionRate > 60 && row.completionRate <= 80
              ? 'info'
              : row.completionRate > 80
              ? 'success'
              : '',"height":"0.5rem","value":row.completionRate,"animated":""}}),_c('p',{staticStyle:{"font-size":"12px","margin":"0px"}},[_vm._v(" "+_vm._s(_vm.$l('tips_input_rateOfProgress') || 'Completion')+": "+_vm._s(row.completionRate)+"% ")])],1)]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }